/**
 * Video Player shared block scripts
 * This file gets shared between the
 * theme and editor.
 */

document.querySelectorAll('.video-player')?.forEach((player) => {
	// cache elements
	const media = player.querySelector('.video-player__media')
	// create a button
	const button = document.createElement('button')
	button.setAttribute('aria-label', 'Play Video')
	button.classList.add('video-player__play')
	// on click of the button
	button.addEventListener('click', () => {
		// set player to visually acgtive
		player.classList.toggle('video-player--active')
		// play vimeo videos
		const iframe = media.querySelector('iframe')
		if (iframe) {
			const { src } = iframe.dataset
			if (src) {
				if (!iframe.src.includes('&autoplay=1')) {
					iframe.src = `${src}&autoplay=1`
				} else {
					iframe.src = src.replace('&autoplay=1', '')
				}
			}
		}
	})
	// add the button to the media column and move the figure into it
	media.append(button)
	button.append(media.firstElementChild)
	// create a faux play button icon and add it to the actual button
	const faux = document.createElement('i')
	faux.setAttribute('aria-hidden', 'true')
	faux.classList.add('video-player__faux-button')
	button.append(faux)
})
